/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { LastMessage, MessageOrigin } from '../typings';
import ChatAnalyticsTick from '../../../../../../../shared/icons/ChatAnalyticsTick';
import ChatAnalyticsError from '../../../../../../../shared/icons/ChatAnalyticsError';
import SingleTickIcon from '../../../../../../../shared/icons/SingleTick';
import { MessageTypesEnum } from '../../../../typings/message-types';

const MessageStatusComponent = ({
  lastMessage,
  getReactionPreview,
}: {
  lastMessage?: LastMessage;
  getReactionPreview: () => {
    text: string;
    name: string;
    isAgent: boolean;
  } | null;
}) => {
  if (
    !lastMessage ||
    lastMessage.messageOriginType !== MessageOrigin.USER ||
    lastMessage.message.messageType === MessageTypesEnum.CALL
  ) {
    return null;
  }

  // Don't show message status if there's a reaction preview
  const reactionPreview = getReactionPreview();
  if (reactionPreview) {
    return null;
  }

  const { readCount, deliveryCount, erroredCount } = lastMessage;

  if (erroredCount) {
    return (
      <ChatAnalyticsError
        css={css`
          height: 16px;
          width: 16px;
        `}
      />
    );
  }

  if (deliveryCount || readCount) {
    return (
      <ChatAnalyticsTick
        css={css(
          `
            height: 16px;
            width: 16px;
          `,
          css(readCount ? `fill: #009de2;` : `fill: #888888;`)
        )}
      />
    );
  }

  return (
    <SingleTickIcon
      css={css(`
          height: 16px;
          width: 16px;
          fill: #888888;
        `)}
    />
  );
};

export default MessageStatusComponent;
